import LoadingScreen from "../../LoadingScreen";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBoards } from "../../../Services/boardsService";
import Navbar from "../../Navbar";
import {
  AddBoard,
  Board,
  BoardCount,
  BoardGrid,
  Container,
  CreateNowButton,
  EmptyState,
  Eyebrow,
  HeroPanel,
  HeroTextGroup,
  SubTitle,
  Title,
  Wrapper,
} from "./Styled";
import CreateBoard from "../../Modals/CreateBoardModal/CreateBoard";
import { useHistory } from "react-router";

const Boards = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { pending, boardsData } = useSelector((state) => state.boards);
  const [openModal, setOpenModal] = useState(false);
  const [searchString, setSearchString] = useState('');
  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleClick = (boardId) => {
    history.push(`/board/${boardId}`);
  };

  useEffect(() => {
    getBoards(false,dispatch);
  }, [dispatch]);

  const filteredBoards = boardsData.filter((item) =>
    searchString ? item.title.toLowerCase().includes(searchString.toLowerCase()) : true
  );

  return (
    <>
      {pending && <LoadingScreen />}
      <Container>
        <Navbar
          searchString={searchString}
          setSearchString={setSearchString}
          searchPlaceholder="Search boards by title"
        />
        <Wrapper>
          <HeroPanel>
            <HeroTextGroup>
              <Eyebrow>Workspace</Eyebrow>
              <Title>Your Boards</Title>
              <SubTitle>Open an existing board or create a new workspace.</SubTitle>
              <BoardCount>
                {filteredBoards.length} {filteredBoards.length === 1 ? "board" : "boards"} visible
              </BoardCount>
            </HeroTextGroup>
            <CreateNowButton onClick={() => setOpenModal(true)}>Create new board</CreateNowButton>
          </HeroPanel>
          {searchString && filteredBoards.length === 0 && (
            <EmptyState>No boards match "{searchString}". Try a different name.</EmptyState>
          )}
          <BoardGrid>
            {!pending &&
              filteredBoards.map((item) => {
                return (
                  <Board
                    key={item._id}
                    link={item.backgroundImageLink}
                    isImage={item.isImage}
                    onClick={() => handleClick(item._id)}
                  >
                    {item.title}
                  </Board>
                );
              })}
            {!pending && <AddBoard onClick={() => setOpenModal(true)}>Create new board</AddBoard>}
          </BoardGrid>
          {openModal && <CreateBoard callback={handleModalClose} />}
        </Wrapper>
      </Container>
    </>
  );
};

export default Boards;
